// extracted by mini-css-extract-plugin
module.exports = {"covidAlert":"CovidAlert_covidAlert__3UnVi","close":"CovidAlert_close__2Rab7","scrolled":"CovidAlert_scrolled__13Ck4"};